import { Typography } from '@mui/material';
import type { ReactNode } from 'react';

import ErrorIcon from '~/assets/icons/new/error.svg?react';
import SuccessIcon from '~/assets/icons/new/successCircle.svg?react';

import useStyles from './ActivationProgressSnackbar.styles';

type ActivationCompletionRowProps = {
  testId: string;
  isFailure?: boolean;
  text: string;
  children?: ReactNode;
};

const ActivationCompletionRow = ({
  testId,
  isFailure = false,
  text,
  children,
}: ActivationCompletionRowProps): JSX.Element => {
  const { classes } = useStyles();
  const Icon = isFailure ? ErrorIcon : SuccessIcon;

  return (
    <div className={classes.completionRow} data-testid={testId}>
      <Icon
        className={classes.completionIcon}
        aria-hidden="true"
        focusable={false}
      />
      <Typography
        variant="caption_regular"
        component="span"
        className={classes.completionText}
      >
        {text}
        {children}
      </Typography>
    </div>
  );
};

export default ActivationCompletionRow;
